var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { COUNTRIES } from "@/lib/countries";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { LIMIT_ACCESS_BY_COUNTRIES } from "@/queries/limitAccessByCountries";
import { useMutation } from "@apollo/client";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { AutocompleteArrayInput, SaveButton, SimpleForm, useEditController, useNotify, } from "react-admin";
import { useTranslation } from "react-i18next";
export var SettingsCountries = function () {
    var tenantId = useTenantStore()[0];
    var t = useTranslation().t;
    var notify = useNotify();
    var limitAccessByCountries = useMutation(LIMIT_ACCESS_BY_COUNTRIES)[0];
    var _a = useEditController({
        resource: "sequent_backend_tenant",
        id: tenantId,
        redirect: false,
        undoable: false,
    }), record = _a.record, save = _a.save;
    var _b = useState([]), selectedVotingCountries = _b[0], setSelectedVotingCountries = _b[1];
    var _c = useState([]), selectedEnrollmentCountries = _c[0], setSelectedEnrollmentCountries = _c[1];
    useEffect(function () {
        var _a, _b;
        if (record && (record === null || record === void 0 ? void 0 : record.settings)) {
            setSelectedVotingCountries((_a = record.settings.voting_countries) !== null && _a !== void 0 ? _a : []);
            setSelectedEnrollmentCountries((_b = record.settings.enroll_countries) !== null && _b !== void 0 ? _b : []);
        }
    }, [record]);
    var handleSumbit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var errors, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!save)
                        return [2 /*return*/];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, limitAccessByCountries({
                            variables: {
                                votingCountries: selectedVotingCountries,
                                enrollCountries: selectedEnrollmentCountries,
                            },
                        })];
                case 2:
                    errors = (_c.sent()).errors;
                    if (errors === null || errors === void 0 ? void 0 : errors.length)
                        throw new Error(errors[0].message);
                    return [4 /*yield*/, save({
                            settings: __assign(__assign({}, ((_b = record === null || record === void 0 ? void 0 : record.settings) !== null && _b !== void 0 ? _b : {})), { voting_countries: selectedVotingCountries, enroll_countries: selectedEnrollmentCountries }),
                        })];
                case 3:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = _c.sent();
                    notify(t("settings.countries.error.errorSaving"), { type: "error" });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(SimpleForm, { className: "countries-form", toolbar: _jsx(SaveButton, { className: "save" }), resource: "sequent_backend_tenant", onSubmit: handleSumbit, record: record, children: [_jsx(Typography, { className: "title", variant: "h4", children: t("settings.countries.title") }), _jsx(Typography, { className: "description", variant: "body2", children: t("settings.countries.votingDescription") }), _jsx(AutocompleteArrayInput, { fullWidth: true, className: "country-list-input", source: "settings.voting_countries", label: "Countries", choices: COUNTRIES, onChange: setSelectedVotingCountries, optionValue: "code" }), _jsx(Typography, { className: "description", variant: "body2", children: t("settings.countries.enrollmentDescription") }), _jsx(AutocompleteArrayInput, { fullWidth: true, className: "country-list-input", source: "settings.enroll_countries", label: "Countries", choices: COUNTRIES, onChange: setSelectedEnrollmentCountries, optionValue: "code" })] }));
};
